import axios from 'axios';
import { getToken, removeToken } from '../utils/token-util';
import router from '@/router';
// removeToken
const BASE_URL = process.env.VUE_APP_API_BASE_URL;

const service = axios.create({
    baseURL: BASE_URL,
    // timeout: 10000,
    headers: { 'Content-Type': 'application/json' },
});

// request 拦截器
service.interceptors.request.use(
    (config) => {
        if (config.url == "/business/alioss/ossSingleUpload" ||config.url == '/mobile/ossUpload') {
            config.headers['Content-Type'] = 'multipart/form-data';
        }
        // console.log(config.route?.name);
        if (config.route?.name !== 'Home' || config.route?.name !== 'ActiveInfo' || config.route?.name !== 'Scancode') {
            // removeToken()
            const token = getToken();
            config.headers.Authorization = token;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// response 拦截器
service.interceptors.response.use(
    (res) => {
        if (res.data.code == 401) {
            removeToken()
            router.push("/");
        } else {
            //   ElMessage.error('token身份令牌过期,请重新登录');
            //   router.push("/login");
            return res;
        }
    },
    (error) => {
        return Promise.reject(error);
    }
);
export default service